
import _ from 'lodash';
import { mapState } from 'vuex';
import { DirectUpload } from 'activestorage';
import { loadVideoThumbnail } from '@/lib/video';
import HttpStatus from '@/enums/HttpStatus';
import AddMediaPopup from './AddMediaPopup';

export default {
  i18nComponentKey: 'ReviewsEditLegacy.components.MediaField',
  name: 'MediaField',
  components: { AddMediaPopup },
  model: { prop: 'media', event: 'change' },
  props: {
    media: { type: Array, required: true }
  },
  data() {
    return { showAddMediaPopup: false, items: [] };
  },
  computed: {
    ...mapState(['api']),
    ...mapState('window', ['windowService'])
  },
  watch: {
    items: {
      handler() {
        this.$emit(
          'change',
          this.items.filter(e => e.type !== 'none').map(e => _.omit(e, 'key'))
        );
      },
      deep: true
    }
  },
  created() {
    const MAX_MEDIA_COUNT = 4;
    this.items = Array.from({ length: MAX_MEDIA_COUNT }, (_, i) => {
      const medium = this.media[i];
      return {
        key: this.generateMediaKey(),
        ...(medium || { type: 'none' })
      };
    });
  },
  methods: {
    onClickDeleteButton(item) {
      this.items = [
        ...this.items.filter(e => e !== item),
        { key: this.generateMediaKey(), type: 'none' }
      ];
    },
    onClickAddMedium() {
      this.showAddMediaPopup = true;
    },
    generateMediaKey() {
      this.mediaKey = this.mediaKey || 0;
      this.mediaKey += 1;
      return `media${this.mediaKey}`;
    },
    onAddImage() {
      const index = this.items.findIndex(e => e.type === 'none');
      this.items.splice(index, 1, {
        key: this.items[index].key,
        type: 'image',
        thumbnail_url: '',
        url: ''
      });
      this.$nextTick(() =>
        this.$refs.items[index].querySelector('input[type=file]').click()
      );
    },
    onChangeImage(item, event) {
      this.showAddMediaPopup = false;
      const fileReader = new FileReader();
      fileReader.addEventListener(
        'load',
        () => (item.thumbnail_url = fileReader.result)
      );
      fileReader.readAsDataURL(event.target.files[0]);
    },
    onAddVideo() {
      const index = this.items.findIndex(e => e.type === 'none');
      this.items.splice(index, 1, {
        key: this.items[index].key,
        type: 'video',
        thumbnail_url: '',
        id: null,
        uploading: false
      });
      this.$nextTick(() =>
        this.$refs.items[index].querySelector('input[type=file]').click()
      );
    },
    onChangeVideo(item, event) {
      item.uploading = true;
      this.showAddMediaPopup = false;

      // https://issues.chromium.org/issues/40123366 <- 안드로이드 웹뷰 엔진인 크로미움의 특정 버전에서 input으로부터의 file read가 제대로 동작하지 않는다는 이슈
      // HACK - ArrayBuffer를 사용해 file의 복제본을 만들어서 file read를 하면 동작한다.
      const selectedFile = event.target.files[0];
      selectedFile.arrayBuffer().then(buffer => {
        const file = new File([buffer], selectedFile.name, {
          type: selectedFile.type
        });
        loadVideoThumbnail(file).then(url => (item.thumbnail_url = url));

        new DirectUpload(file, this.api.getVideoDirectUploadUrl(), {
          directUploadWillStoreFileWithXHR: request => {
            request.upload.addEventListener('progress', event => {
              const index = this.items.findIndex(e => e === item);
              this.$refs.items[index].querySelector(
                '.MediaField__progress-bar'
              ).style.width = `${(event.loaded / event.total) * 100}%`;
            });
          }
        }).create((error, blob) => {
          if (error) {
            const hit = error.match(/Status: (\d+)/);
            let message;
            switch (parseInt(hit[1])) {
              case HttpStatus.REQUEST_TOO_LONG:
                message = this.$t('video_upload_error.too_large');
                break;
              case HttpStatus.UNSUPPORTED_MEDIA_TYPE:
                message = this.$t('video_upload_error.invalid_type');
                break;
              default:
                message = this.$t('video_upload_error.default');
                break;
            }

            this.windowService.alert(message);
            return;
          }

          this.api
            .createVideo(blob.id)
            .then(({ data }) => (item.id = data.id))
            .catch(() =>
              this.windowService.alert(this.$t('video_create_error.default'))
            )
            .finally(() => (item.uploading = false));
        });
      });
    }
  }
};
